import React from 'react';

import CategorizerBody from './CategorizerBody';
import CategorizerHeading from './CategorizerHeading';
import useCategorizer from './useCategorizer';

import './Categorizer.scss';

const Categorizer: React.FC = () => {
    const {
        tournamentIds,
        openedSportIds,
        sportIds,
        handleFiltersChange,
        handleSportPreviewClick,
    } = useCategorizer();

    return (
        <div styleName="container" className="__app-Categorizer-container">
            <CategorizerHeading />

            <CategorizerBody
                tournamentIds={tournamentIds}
                openedSportIds={openedSportIds}
                selectedSportIds={sportIds}
                onFilterChange={handleFiltersChange}
                onSportPreviewClick={handleSportPreviewClick}
            />
        </div>
    );
};

export default Categorizer;
